import { ApplicationsItemType } from '@marketplace/api';

import { TEMApplication, EMApplicationStatuses } from './embed-mode.types';

export const transformAPIToEMData = (data: Partial<ApplicationsItemType> & Required<{ id: string, status: EMApplicationStatuses }>): TEMApplication => ({
  appId: data.id,
  appName: data.name || '',
  company: data.company_name || '',
  developer: data.developer_name || '',
  description: data.short_description || '',
  status: data.status,
  launchURI: data?.launch_url || '',
  iconUri: data.icon || '',
  scopes: data?.scopes || [],
  additionalSettings: null,
  oauthclienttype:data?.oauthclienttype || '',
  oauthclientmechanism:data?.oauthclientmechanism || '',
  facing:data?.facing || '',
  products:data?.products || [],
  application_launch_type: data?.application_launch_type || [],
  clientid: data?.client_id || ''
});
